import { useMutation } from '@tanstack/react-query';
import type { TFormValues } from 'legacy/templates/modules/sign-up/types/TFormValues';
import { postUser } from 'api/resources/signUp';

export const usePostUser = () => {
	return useMutation((params: TFormValues) => postUser(params));
};
